'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a button used in the menu to switch between tabs
 *
 * @class
 */

class TopNavTabButton extends Core {

    _defaults() {
        return {
            target: '.js-sitemenu__right__tabs',
            fields: {
                'name': undefined,
                'link': '#tab',
                'icon': undefined,
                'description': undefined,
                'border': false
            }
        };
    }

    constructor(options) {
        super(options);

        var borderClass = '';

        if(this._options.fields.border == 'left'){
            borderClass = 'editor__topnav__tabbutton__link--leftborder';
        }else if(this._options.fields.border == 'right'){
            borderClass = 'editor__topnav__tabbutton__link--rightborder';
        }
        
        this.template = `
            <div class='float'>
                <div class='editor__topnav__tabbutton editor__topnav__tabbutton<% if (name != undefined) {  %><%- " editor__topnav__tabbutton--" + name.replace(" ","-").toLowerCase() %><% } %>'>
                    <div class='editor__topnav__tabbutton__notification js-editor__topnav__tabbutton__notification'></div>
                    <a href="<%= external_url(link) %>" title="<% if (description != undefined) { %><%-description%><% } else { %><%-name%><% } %>">
                        <div class="editor__topnav__tabbutton__link ${borderClass} js-editor__topnav__tabbutton__link">
                            <% if (icon != undefined) { %><%= embedded_svg(icon) %><% } %>
                        </div>
                    </a>
                </div>
            </div>
        `;

        super.render();

        // hide notification by default
        $('.js-editor__topnav__tabbutton__notification', this.$el).hide();

        /**
         * Click event
         *
         * @fires TopNavTabButton#_clicked
         */

         $(this.$el).on('click', this._clicked);
    }

    /**
     * @event TopNavTabButton#Cioui:MenuTabButon:clicked
     * @property {String}Cioui:MenuTabButon:clicked
     * @returns {Object} event - native click Event
     */

    _clicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:MenuTabButon:clicked', e);
    }

    /**
     * Sets the button active
     */

    addNotificationNumber(notificationNumber){
        if(notificationNumber > 0){
            $('.js-editor__topnav__tabbutton__notification', this.$el).show();
            $('.js-editor__topnav__tabbutton__notification', this.$el).html(notificationNumber);
        }else{
            $('.js-editor__topnav__tabbutton__notification', this.$el).hide();
        }
    }

    /**
     * Sets the button active
     */

    setActive(){
        $('.js-editor__topnav__tabbutton__link', this.$el).addClass('editor__topnav__tabbutton__link--active');
    }

    /**
     * Sets the button inactive
     */

    setInactive(){
        $('.js-editor__topnav__tabbutton__link', this.$el).removeClass('editor__topnav__tabbutton__link--active');
    }

    /**
     * Add left border
     */

    addLeftBorder(){
        $('.js-editor__topnav__tabbutton__link', this.$el).addClass('editor__topnav__tabbutton__link--leftborder');
    }

    /**
     * Add right border
     */

    addRightBorder(){
        $('.js-editor__topnav__tabbutton__link', this.$el).addClass('editor__topnav__tabbutton__link--rightborder');
    }

}
module.exports = TopNavTabButton;
